// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"253": "BufferOp","40": "OLparser","420": "lineSplit","448": "Polygonizer","930": "UnionOp",}[chunkId] || chunkId) + ".bundle.js"
}// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"253": "BufferOp","40": "OLparser","420": "lineSplit","448": "Polygonizer","930": "UnionOp",}[chunkId] || chunkId) + ".bundle.js"
}